var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo375(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 40,
    viewBox: "0 0 74 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_477_1247)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.992188 4.09459C0.992188 2.31923 2.47138 0.880016 4.29606 0.880016C6.12073 0.880016 7.59992 2.31923 7.59992 4.09459V21.5452H0.992188V4.09459Z",
    fill: "url(#paint0_linear_477_1247)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2561 22.1789C34.3771 22.4361 36.139 20.6402 35.5522 18.6404C34.4003 14.7149 32.4411 10.2899 29.8692 8.3304C26.3318 5.63536 21.878 4.33378 17.3969 4.68548C12.9158 5.03719 8.73699 7.01631 5.69473 10.2278C2.65244 13.4393 0.970432 17.6468 0.984462 22.0106C0.998485 26.3744 2.70752 30.5733 5.7704 33.7693C8.83327 36.9653 13.0247 38.9232 17.508 39.2521C21.9913 39.5811 26.4366 38.257 29.9567 35.544C32.6039 33.5038 34.5813 30.7909 35.6906 27.7368C36.3001 26.0591 35.0323 24.3963 33.2247 24.1248C31.4178 23.8535 29.7684 25.0956 28.9744 26.698C28.2447 28.1701 27.1774 29.4769 25.8373 30.5098C23.6222 32.2169 20.825 33.0502 18.0038 32.8432C15.1827 32.6361 12.5452 31.4041 10.6179 29.3931C8.6905 27.382 7.61511 24.7397 7.60629 21.9938C7.59747 19.2479 8.65589 16.6002 10.5703 14.5793C12.4846 12.5585 15.1142 11.3132 17.9339 11.0919C20.7537 10.8705 23.5563 11.6895 25.7822 13.3855C27.4406 14.6489 28.6474 17.245 29.3405 19.608C29.7317 20.9416 30.8417 22.0075 32.2561 22.1789Z",
    fill: "url(#paint1_linear_477_1247)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.4766 4.09459C66.4766 2.31923 67.9557 0.880016 69.7804 0.880016C71.6051 0.880016 73.0843 2.31923 73.0843 4.09459V22.6932H66.4766V4.09459Z",
    fill: "url(#paint2_linear_477_1247)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8832 24.1383C39.0735 24.3611 37.763 25.9849 38.3216 27.6745C39.342 30.7601 41.239 33.5278 43.8239 35.64C47.258 38.4463 51.6534 39.8894 56.133 39.6812C60.6125 39.4729 64.8466 37.6288 67.9902 34.5168C71.1337 31.4048 72.9555 27.2538 73.0918 22.8924C73.2283 18.531 71.6692 14.2799 68.7259 10.9877C65.7827 7.69549 61.6717 5.6043 57.2135 5.13149C52.7552 4.65868 48.2777 5.83905 44.6746 8.43702C42.0743 10.3119 39.9796 14.6743 38.7021 18.5689C38.0487 20.5609 39.8193 22.3855 41.9461 22.0863C43.2704 21.8999 44.308 20.9079 44.7286 19.6719C45.5176 17.3535 46.8866 14.8416 48.6075 13.6008C50.8748 11.966 53.6923 11.2232 56.4977 11.5207C59.303 11.8183 61.89 13.1342 63.742 15.2058C65.5941 17.2775 66.5751 19.9525 66.4892 22.6969C66.4034 25.4414 65.2571 28.0534 63.279 30.0116C61.3009 31.9699 58.6366 33.1303 55.8178 33.2614C52.999 33.3924 50.2331 32.4844 48.0722 30.7185C46.763 29.6487 45.7342 28.3116 45.0478 26.8181C44.3031 25.1979 42.6929 23.9154 40.8832 24.1383Z",
    fill: "url(#paint3_linear_477_1247)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.0156 35.1515H70.9301C71.126 35.1515 71.2949 35.1959 71.4366 35.2847C71.5796 35.3717 71.6899 35.5005 71.7672 35.671C71.8458 35.8397 71.8851 36.0475 71.8851 36.2943C71.8851 36.4773 71.8574 36.6433 71.802 36.7925C71.7466 36.9417 71.6693 37.066 71.57 37.1655C71.472 37.2649 71.3586 37.3333 71.2298 37.3706L71.1485 37.4159H70.1722L70.1683 37.1335H70.9823C71.1305 37.1335 71.2536 37.0945 71.3515 37.0163C71.4495 36.9364 71.523 36.8325 71.5719 36.7046C71.6222 36.5767 71.6474 36.44 71.6474 36.2943C71.6474 36.0297 71.5855 35.8201 71.4618 35.6657C71.3393 35.5111 71.1621 35.4339 70.9301 35.4339H70.2553V39.0303H70.0156V35.1515ZM71.7517 39.0303L71.0248 37.296L71.28 37.2907L72.0069 38.9956V39.0303H71.7517Z",
    fill: "url(#paint4_linear_477_1247)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.0013 37.0909C74.0013 38.6975 72.664 40 71.0143 40C69.3647 40 68.0273 38.6975 68.0273 37.0909C68.0273 35.4842 69.3647 34.1818 71.0143 34.1818C72.664 34.1818 74.0013 35.4842 74.0013 37.0909ZM71.0114 39.6364C72.546 39.6364 73.6276 38.5855 73.6276 37.0909C73.6276 35.5964 72.546 34.5455 71.0114 34.5455C69.4768 34.5455 68.3953 35.5964 68.3953 37.0909C68.3953 38.5855 69.4768 39.6364 71.0114 39.6364Z",
    fill: "#F583EB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_477_1247",
    x1: 0.733064,
    y1: -0.802013,
    x2: 8.1573,
    y2: -0.75366,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6F1F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.364583,
    stopColor: "#F983E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.739583,
    stopColor: "#B877FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C2E9CD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_477_1247",
    x1: 1.81141,
    y1: -0.00922979,
    x2: 41.5788,
    y2: 5.05162,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6F1F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.364583,
    stopColor: "#F983E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.739583,
    stopColor: "#B877FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C2E9CD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_477_1247",
    x1: 66.2174,
    y1: -0.89546,
    x2: 73.6417,
    y2: -0.84965,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6F1F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.364583,
    stopColor: "#F983E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.739583,
    stopColor: "#B877FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C2E9CD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_477_1247",
    x1: 75.8917,
    y1: 41.1731,
    x2: 35.9461,
    y2: 43.1989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6F1F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.364583,
    stopColor: "#F983E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.739583,
    stopColor: "#B877FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C2E9CD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_477_1247",
    x1: 69.9375,
    y1: 34.8358,
    x2: 72.1748,
    y2: 34.8592,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6F1F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.364583,
    stopColor: "#F983E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.739583,
    stopColor: "#B877FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C2E9CD"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_477_1247"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 74,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo375);
export default __webpack_public_path__ + "static/media/logo375.e08ae2436751c167bdba589402171bb9.svg";
export { ForwardRef as ReactComponent };